import { Drawer } from '@cartwheel/components'
import type React from 'react'

export function TaskDrawerFrame({
  title,
  titleContext,
  onClose,
  children,
}: {
  title: string
  titleContext?: string | null
  onClose: () => void
  children: React.ReactNode
}) {
  return (
    <Drawer.Root
      open
      onOpenChange={(open) => {
        if (!open) onClose()
      }}
      swipeDirection="right"
    >
      <Drawer.Portal>
        <Drawer.Backdrop className="fixed inset-0 z-10 bg-black/50 transition-opacity duration-300 data-[starting-style]:opacity-0 data-[ending-style]:opacity-0 motion-reduce:transition-none" />
        <Drawer.Viewport className="fixed inset-0 z-20 flex items-stretch justify-end">
          <Drawer.Popup className="relative flex h-full w-[1000px] max-w-[calc(100vw-32px)] flex-col overscroll-contain bg-white shadow-lg transition-transform duration-300 data-[starting-style]:translate-x-full data-[ending-style]:translate-x-full motion-reduce:transition-none">
            <header className="flex h-20 shrink-0 items-center justify-between border-b border-gray-stroke px-6">
              <Drawer.Title className="flex min-w-0 flex-wrap items-baseline gap-x-2 text-xl font-semibold leading-[1.5] text-charcoal">
                <span>{title}</span>
                {titleContext && (
                  <span className="text-sm font-normal text-charcoal-50">· {titleContext}</span>
                )}
              </Drawer.Title>
              <Drawer.Close
                type="button"
                className="flex size-8 items-center justify-center rounded text-charcoal hover:bg-sand-25 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-forest focus-visible:ring-offset-2"
                aria-label="Close task details"
              >
                <i className="fa-solid fa-xmark text-base" aria-hidden="true" />
              </Drawer.Close>
            </header>
            {children}
          </Drawer.Popup>
        </Drawer.Viewport>
      </Drawer.Portal>
    </Drawer.Root>
  )
}
